import { render, staticRenderFns } from "./MyComponent.vue?vue&type=template&id=0fb969d0"
import script from "./MyComponent.vue?vue&type=script&lang=js"
export * from "./MyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports